import React, { useEffect, useState } from "react";
import { Button, DatePicker, Form, Input, InputNumber, TimePicker, message } from "antd";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router";
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

const UpdateSupport = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const params = useParams()
  const id = params.id
  const navigate = useNavigate()
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchSupport = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${apiUrl}/api/support/${id}`);
        const data = await response.json();

        if (response.ok) {
          form.setFieldsValue({
            isim: data.firstName,
            soyisim: data.lastName,
            mesaj: data.message,
            blok: data.blockNum,
            telefon: data.phoneNumber,
            tarih: dayjs(data.repairDate), 
            baslangicSaati: dayjs(data.startTime, "HH:mm"),
            bitisSaati: dayjs(data.endTime, "HH:mm"),
          });
        } else {
          message.error("Veri alınamadı: " + data.error);
        }
      } catch (error) {
        console.error("Hata:", error);
        message.error("Bir hata oluştu.");
      } finally {
        setLoading(false);
      }
    };

    fetchSupport();
  }, [apiUrl,id,form]);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await fetch(`${apiUrl}/api/support/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: values.isim,
          lastName: values.soyisim, 
          message: values.mesaj,
          blockNum: values.blok, 
          phoneNumber: values.telefon, 
          repairDate: values.tarih.format("YYYY-MM-DD"), 
          startTime: values.baslangicSaati.format("HH:mm"), 
          endTime: values.bitisSaati.format("HH:mm"), 
        }),
      });
  
      if (response.ok) {
        message.success("Destek kaydı başarıyla güncellendi!");
        navigate("/admin/support");
      } else {
        const data = await response.json();
        message.error("Güncelleme başarısız: " + data.error);
      }
    } catch (error) {
      console.error("Hata:", error);
      message.error("Bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  const onTimeChange = (time, timeString, field) => {
    console.log(`${field}:`, timeString);
  };

  return (
    <>
      <Form
        {...formItemLayout}
        form={form}
        style={{ width: "100%" }}
        initialValues={{
          variant: "filled",
        }}
        onFinish={onFinish}
      >
        <Form.Item
          label="İsim"
          name="isim"
          rules={[
            {
              required: true,
              message: "Lütfen isminizi giriniz!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Soyisim"
          name="soyisim"
          rules={[
            {
              required: true,
              message: "Lütfen soyisminizi giriniz!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Mesaj"
          name="mesaj"
          rules={[
            {
              required: true,
              message: "Lütfen mesajınızı giriniz!",
            },
          ]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Blok Numarası"
          name="blok"
          rules={[
            {
              required: true,
              message: "Lütfen blok numaranızı giriniz!",
            },
          ]}
        >
          <InputNumber />
        </Form.Item>

        <Form.Item
          label="Telefon"
          name="telefon"
          rules={[
            {
              required: true,
              message: "Lütfen telefon numaranızı giriniz!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
  label="Onarım Tarihi"
  name="tarih"
  rules={[
    {
      required: true,
      message: "Lütfen bir tarih seçiniz!",
    },
  ]}
>
  <DatePicker />
</Form.Item>


        <Form.Item
          label="Başlangıç Saati"
          name="baslangicSaati"
          rules={[
            {
              required: true,
              message: "Lütfen başlangıç saatini seçiniz!",
            },
          ]}
        >
          <TimePicker
            format="HH:mm"
            onChange={(time, timeString) => onTimeChange(time, timeString, "Başlangıç")}
          />
        </Form.Item>

        <Form.Item
          label="Bitiş Saati"
          name="bitisSaati"
          rules={[
            {
              required: true,
              message: "Lütfen bitiş saatini seçiniz!",
            },
          ]}
        >
          <TimePicker
            format="HH:mm"
            onChange={(time, timeString) => onTimeChange(time, timeString, "Bitiş")}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Güncelle
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default UpdateSupport;
